
export const openChatWidget = () => {
  if (window.zE) {
    zE('webWidget', 'open');
  }
};
